"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var three_sixty_rater_single_display_logic_html_1 = __importDefault(require("./three-sixty-rater-single-display-logic.html"));
var raterSingleDisplayLogicComponent = {
    templateUrl: three_sixty_rater_single_display_logic_html_1.default,
    controller: 'prRaterSingleDisplayLogicController',
    bindings: {
        singleDisplayLogic: '='
    }
};
(function (angularModule) {
    angularModule.component('prRaterSingleDisplayLogic', raterSingleDisplayLogicComponent);
})(angular_1.default.module('qualtrics.pr'));
exports.default = raterSingleDisplayLogicComponent;
